<template>
  <div id="refund-wrapper">
    <BottomBar />
    <Modal
      v-if="components.help"
      title="关于提现"
      :showClose="true"
      :tapToDismiss="true"
      :showComplete="false"
      v-on:dismiss="components.help = false"
    >
      <Help />
    </Modal>
    <Empty
      v-if="!data || !data.length"
      :icon="true"
      :loading="data === undefined"
      title="暂无提现"
      subtitle="您还没有收到可提现的金额"
    >
      <div @click="components.help = true" class="help">
        <i class="anyteachicon anyteach-help" />
        <span>关于提现</span>
      </div>
      <router-link to="/invite/reward" tag="div" class="help">
        <span>我的提成规则</span>
      </router-link>
    </Empty>
    <div v-else id="refund">
      <div ref="top" class="top top-down">
        <h1 ref="title" class="title down">累计提现 ¥{{ total }}</h1>
        <h2 ref="count" class="count">{{ data.filter(i => i.status === 2).length }} 单收入</h2>
      </div>
      <main>
        <div class="shortcut">
          <router-link to="/invite/reward" tag="div" class="help link">
            <span>我的提成规则</span>
            <i class="anyteachicon anyteach-next1" />
          </router-link>
          <div @click="components.help = true" class="help">
            <i class="anyteachicon anyteach-help" />
            <span>关于提现</span>
          </div>
        </div>
        <Item v-for="(item, index) in data" :key="index" :data="item" @click="goTo(item.id)" />
      </main>
    </div>
  </div>
</template>
<script>
import Item from "./Item"
import Help from "./Help"

export default {
  name: "Refund",
  components: { Item, Help },
  data() {
    return {
      data: undefined,
      components: {
        help: false
      }
    }
  },
  created() {
    if (this.$route.query.id) return this.goTo(this.$route.query.id)
    if (this.$route.query.event === "name" || this.$route.query.event === "error") this.components.help = true
    this.wechatInit()
    this.getData()
    this.$on("hook:beforeDestroy", () => window.onscroll = null)
  },
  computed: {
    total() {
      if (!this.data) {
        return 0
      }
      return parseFloat(
        this.data
          .filter(i => i.status == 2)
          .reduce((sum, i) => (sum += parseFloat(i.refund_amount)), 0),
      ).toFixed(2)
    },
  },
  methods: {
    bindScroll() {
      this.checkScroll()
      window.onscroll = () => {
        this.checkScroll()
      }
    },
    checkScroll() {
      const isScroll = window.scrollY > 10
      this.setClass(isScroll)
    },
    setClass(isScroll) {
      if (!this.$refs.title || !this.$refs.title || !this.$refs.count) return
      if (isScroll) {
        this.$refs.top.classList.remove("top-down")
        this.$refs.top.classList.add("top-up")

        this.$refs.title.classList.remove("down")
        this.$refs.title.classList.add("up")

        this.$refs.count.classList.add("hide")
      } else {
        this.$refs.top.classList.remove("top-up")
        this.$refs.top.classList.add("top-down")

        this.$refs.title.classList.remove("up")
        this.$refs.title.classList.add("down")

        this.$refs.count.classList.remove("hide")
      }
    },
    goTo(id) {
      this.$router.push("/cash/" + id)
    },
    async getData() {
      this.data = await this.$api.order.CASH_LIST()
      this.$nextTick(() => this.bindScroll())
    },
    wechatInit() {
      wx.ready(() => {
        this.$wxShare({
          title: `${window.document.title}`,
          imgUrl: window.logo2019,
          desc: "查看你的现金奖励，最高上千元。",
          link: window.homePageUrl + this.$route.fullPath
        })
      })
    },
  },
}
</script>
<style scoped lang="scss">
@import "./style.scss";
#refund-wrapper {
  min-height: 100vh;
  background: white;
  font-family: Avenir, -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji,
    Segoe UI Symbol;
  .empty {
    height: 75vh;
    background: none;
    .help {
      text-align: center;
      opacity: 1;
      color: $primary;
      font-size: 0.9rem;
      @include avenir-demi();
      &:active {
        opacity: 0.6;
      }
    }
  }
}
#refund {
  padding-top: 80px;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  margin-bottom: 10px;
  main {
    margin: 5px 0 0 0;
    padding: 0 5%;
  }
  .top {
    position: fixed;
    background: white;
    width: 100%;
    z-index: 1;
    top: 0;
    left: 0;
    border-bottom: 1px solid #eee;
    margin: 0;
    transition: all 0.25s;
    height: 80px;
  }
  .title {
    font-size: 1.6rem;
    @include avenir-demi();
    transition: all 0.25s;
    transform-origin: center;
    position: absolute;
    margin: 0;
    padding: 0;
    display: block;
    white-space: nowrap;
    color: $primary;
  }
  .count {
    transition: all 0.25s;
    font-size: 1rem;
    font-weight: 400;
    opacity: 0.6;
    right: 5%;
    position: absolute;
    margin: 0;
    padding: 0;
    bottom: 8px;
  }
  .top-up {
    height: 35px;
    background-color: rgba($color: white, $alpha: 1);
    border-color: rgba($color: #eee, $alpha: 1);
  }
  .top-down {
    height: 80px;
    background-color: rgba($color: white, $alpha: 0);
    border-color: rgba($color: #eee, $alpha: 0);
  }
  .up {
    transform: translate(-50%, 50%) scale(0.6);
    left: 50%;
    bottom: 50%;
    color: $black;
    opacity: 0.6;
  }
  .down {
    transform: translate(0, 0);
    left: 5%;
    bottom: 8px;
  }
  .hide {
    opacity: 0;
  }
}
</style>
